import { render, staticRenderFns } from "./HistoryLimitsStatus.vue?vue&type=template&id=c68930de&"
import script from "./HistoryLimitsStatus.vue?vue&type=script&lang=js&"
export * from "./HistoryLimitsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports